module.exports = __webpack_public_path__ + "static/whoami-31a6851e2832f2a792642d16b6160b58.png";